export interface StudioLocation {
  name?: unknown;
  path: string;
  params: Record<string, unknown>;
  query: Record<string, unknown>;
}

export interface PersistentStudioWorkspace {
  key: string;
  projectId?: string;
  taskActive: boolean | null;
}

function scalarRouteValue(value: unknown): string {
  if (typeof value === 'string')
    return value.trim();
  return Array.isArray(value) && typeof value[0] === 'string' ? value[0].trim() : '';
}

export function studioIdentity(location: StudioLocation): PersistentStudioWorkspace | null {
  const projectId = scalarRouteValue(location.params.projectId) || scalarRouteValue(location.query.projectId);
  const fixture = scalarRouteValue(location.query.fixture);
  const studioRoute = location.name === 'AiVisualizationStudio'
    || (location.path === '/ai-visualization/studio' && Boolean(projectId || fixture));
  if (!studioRoute)
    return null;
  return { key: projectId || `fixture:${fixture || location.path}`, projectId: projectId || undefined, taskActive: null };
}

export function shouldRenderStudioWorkspace(workspace: PersistentStudioWorkspace, currentKey?: string): boolean {
  return workspace.key === currentKey || workspace.taskActive !== false;
}
